// @flow

import _ from 'lodash';

import ApiObject from '../ApiObject';
import ProPermissionsList from './ProPermissionsList';

export default class ProRole extends ApiObject {

  id: string;

  name: string = '';

  permissions: ProPermissionsList = new ProPermissionsList();

  restaurantsGroupId: string;

  //
  // Validation
  //

  /**
   * Verify that the object is correct
   */
  isValid(): boolean {
    return this.validateName()
      && this.validatePermissions();
  }

  validateName(): boolean {
    return !_.isEmpty(this.name);
  }

  validatePermissions(): boolean {
    return true;
  }

  static validationErrors = {
    name: 'Le nom ne peut être vide',
    permissions: 'Les permissions sont invalides :('
  };

  getValidationErrors(): Object {
    const validationErrors = ProRole.validationErrors;
    const errors = {};

    if (!this.validateName()) {
      errors.name = validationErrors.name;
    }

    if (!this.validatePermissions()) {
      errors.description = validationErrors.permissions;
    }

    return errors;
  }
}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/security/ProRole.js